class LocationBasedPopup extends HTMLElement {
  constructor() {
    super();
    this.closeBtnSvg = this.querySelector(".popup-content--close-btn-svg");
    this.closeBtn = this.querySelector(".popup-content--close-btn");
    this.countryShowed = ['TH', 'MY', 'SG', 'PH', 'HK', 'ID'];
    this.countryCode = {
      "TH": "Thailand",
      "MY": "Malaysia",
      "SG": "Singapore",
      "PH": "Philippines",
      "HK": "Hong Kong",
      "ID": "Indonesia"
    };
  
    this.capping = this.dataset.capping;
    this.popupId = this.dataset.popupId;
    this.countryName;

    this.init();
  }

  async init() {
    const userLocationBySuggestion = await this.fetchUserCountry();
    const userCountry = userLocationBySuggestion == "ID" ? "ID" : Shopify.country;

    const popupHasBeenShowed = this.readCookie(this.popupId, userCountry);
    if (popupHasBeenShowed) return;
    
    if (this.countryShowed.includes(userCountry)) {
      this.updateInfo(userCountry);
      this.hideGeolocation();
      this.togglePopup(true);
      this.initCloseBtn();
      this.createCookie(this.popupId, userCountry, 1, this.capping);
    }
  }

  async fetchUserCountry() {
    try {
      const response = await fetch("/browsing_context_suggestions.json");
      const json = await response.json();
      const countryHandle = json?.detected_values?.country.handle;

      return countryHandle;
    } catch (error) {
      console.error("Error fetching user country:", error);
    }
  }

  hideGeolocation() {
    function waitForElement() {
      if (document.querySelector('.recommendation-modal__container') != null) {
        document.querySelector('.recommendation-modal__container').parentElement.style.display = 'none';
      } else {
        setTimeout(waitForElement, 1);
      }
    }

    waitForElement();
  }

  initCloseBtn() {
    this.closeBtnSvg.addEventListener("click", () => this.togglePopup(false));
    this.closeBtn.addEventListener("click", () => this.togglePopup(false));
    document.getElementById("location-based-popup-backdrop").addEventListener("click", () => this.togglePopup(false));
  }

  updateInfo(country) {
    const linkCountry = this.getAttribute(`data-link-${country.toLowerCase()}`);
    
    this.querySelectorAll('.popup-link').forEach(link => {
      link.href = linkCountry;
    });

    this.querySelector('.country').innerHTML = this.countryCode[country];
  }


  togglePopup(visible) {
    visible ? this.classList.remove('hidden') : this.classList.add('hidden');
    document.getElementById("location-based-popup-backdrop").style.display = visible ? "block" : "none";
    document.body.style.overflow = visible ? "hidden" : "initial";
  }

  createCookie(name, country, value, days) {
    const expires = days
    ? `; expires=${new Date(Date.now() + days * 24 * 60 * 60 * 1000).toGMTString()}`
    : "";
    document.cookie = `${name}-${country}=${value}${expires}; path=/`;
    console.log(document.cookie)
  }

  readCookie(name, country) {
    const nameEQ = `${name}-${country}=`;
    return (
      document.cookie
        .split(";")
        .map((cookie) => cookie.trim())
        .find((cookie) => cookie.startsWith(nameEQ)) || ""
    ).slice(nameEQ.length);
  }
}

customElements.define("location-based-popup", class extends LocationBasedPopup  { });